import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPen, faEye, faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import { forwardRef, useState } from "react";

const DotsToggle = forwardRef(({ onClick }, ref) => {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      ref={ref}
      onClick={(e) => { e.preventDefault(); onClick(e); }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? "#f0f0f0" : "transparent",
        border: "none",
        borderRadius: "8px",
        width: "32px",
        height: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        color: "#757575",
        fontSize: "1rem",
        transition: "background 0.15s",
        padding: 0,
      }}
    >
      <FontAwesomeIcon icon={faEllipsisVertical} />
    </button>
  );
});

const menuStyle = {
  borderRadius: "10px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
  border: "1px solid #f0f0f0",
  padding: "6px",
  minWidth: "140px",
};

const itemStyle = (color = "#424242") => ({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  padding: "8px 12px",
  borderRadius: "7px",
  fontSize: "0.88rem",
  fontWeight: 500,
  color,
  cursor: "pointer",
});

const iconBoxStyle = (bg, color) => ({
  width: "26px",
  height: "26px",
  borderRadius: "6px",
  background: bg,
  color,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "0.75rem",
  flexShrink: 0,
});

const CompleteDropdown = ({ deleteAction, editAction, viewAction, extraItems = [] }) => {
  const hasMain = viewAction || editAction;
  return (
    <Dropdown>
      <Dropdown.Toggle as={DotsToggle} />
      <Dropdown.Menu style={menuStyle} popperConfig={{ strategy: "fixed" }} renderOnMount>
        {viewAction && (
          <Dropdown.Item as="div" style={itemStyle()} onClick={viewAction}>
            <span style={iconBoxStyle("#e8f0fe", "#1a73e8")}>
              <FontAwesomeIcon icon={faEye} />
            </span>
            View
          </Dropdown.Item>
        )}
        {editAction && (
          <Dropdown.Item as="div" style={itemStyle()} onClick={editAction}>
            <span style={iconBoxStyle("#e8f5e9", "#2e7d32")}>
              <FontAwesomeIcon icon={faPen} />
            </span>
            Edit
          </Dropdown.Item>
        )}
        {extraItems.map((item, i) => (
          <Dropdown.Item key={i} as="div" style={itemStyle(item.color)} onClick={item.onClick}>
            <span style={iconBoxStyle(item.iconBg, item.iconColor)}>
              <FontAwesomeIcon icon={item.icon} />
            </span>
            {item.label}
          </Dropdown.Item>
        ))}
        {deleteAction && (
          <>
            {(hasMain || extraItems.length > 0) && (
              <div style={{ height: "1px", background: "#f5f5f5", margin: "4px 0" }} />
            )}
            <Dropdown.Item as="div" style={itemStyle("#c62828")} onClick={deleteAction}>
              <span style={iconBoxStyle("#ffebee", "#c62828")}>
                <FontAwesomeIcon icon={faTrash} />
              </span>
              Delete
            </Dropdown.Item>
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CompleteDropdown;
